export const config = {
    initialViewport: {
        width: 400,
        height: 400,
        latitude: 19.37,
        longitude: -99.05,
        zoom: 10.5,
    },
};
